import { injectable, inject } from 'inversify';
import type { IAuthRepository } from '@/domain/repositories/IAuthRepository';
import { User } from '@/domain/entities/User';
import { TYPES } from '@/di/tokens';

@injectable()
export class GetCurrentUserAction {
  constructor(
    @inject(TYPES.IAuthRepository) private authRepository: IAuthRepository
  ) {}

  async execute(): Promise<User | null> {
    return await this.authRepository.getCurrentUser();
  }
}
